import $ from "jquery";
import App from "../App";
import Api from "../App/Api";

require('featherlight/release/featherlight.min');
require('featherlight/release/featherlight.gallery.min');

//require('../../scripts/vendor/markerclusterer');

const GoogleMap = (() => {
  let map;
  const initializeMap = function ($element) {
    const maxBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(parseFloat($element.attr('data-bounds-sw-lat')), parseFloat($element.attr('data-bounds-sw-lng'))),
      new google.maps.LatLng(parseFloat($element.attr('data-bounds-ne-lat')), parseFloat($element.attr('data-bounds-ne-lng'))),
    );
    const minZoom = parseInt($element.attr('data-min-zoom'));
    const maxZoom = parseInt($element.attr('data-max-zoom'));
    map = new google.maps.Map($element.get(0), {
      center: {
        lat: parseFloat($element.attr('data-lat')),
        lng: parseFloat($element.attr('data-lng'))
      },
      zoom: parseInt($element.attr('data-zoom')),
      scrollwheel: false,
      streetViewControl: false,
      mapTypeControl: false,
      scaleControl: false,
      draggable: true,
      navigationControl: true,
      navigationControlOptions: {style: google.maps.NavigationControlStyle.SMALL},
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    Api.googleMap = map;

    google.maps.event.addListener(map, 'drag', function () {
      if (maxBounds.contains(map.getCenter())) {
        return;
      }
      let c = map.getCenter(),
        x = c.lng(),
        y = c.lat(),
        maxX = maxBounds.getNorthEast().lng(),
        maxY = maxBounds.getNorthEast().lat(),
        minX = maxBounds.getSouthWest().lng(),
        minY = maxBounds.getSouthWest().lat();
      if (x < minX) {
        x = minX;
      }
      if (x > maxX) {
        x = maxX;
      }
      if (y < minY) {
        y = minY;
      }
      if (y > maxY) {
        y = maxY;
      }
      map.setCenter(new google.maps.LatLng(y, x));
    });

    google.maps.event.addListener(map, 'zoom_changed', function () {
      if (map.getZoom() < minZoom) {
        map.setZoom(minZoom);
      } else if (map.getZoom() > maxZoom) {
        map.setZoom(maxZoom);
      }
    });


    /*
    const clusterOptions = {
      imagePath: 'assets/template/images/marker_cluster/m',
      maxZoom: 16,
      gridSize: 125,
      averageCenter: true,
      minimumClusterSize: 2
    };
    */

    loadMarkers(map, function (markers) {
      /*
      let markerCluster = new MarkerClusterer(map, markers, clusterOptions);
      markerCluster.setCalculator(function (markers, numStyles) {
        const count = markers.length;
        let index = 0;
        let dv = count;
        while (dv !== 0) {
          dv = parseInt(dv / 5, 10);
          index++;
        }
        index = Math.min(index, numStyles);
        return {
          text: count,
          index: index
        };
      });
      */
    });
  };

  const loadMarkers = function (map, callback) {
    const markers = [];
    $.ajax({
      url: Api.getReportsUrl()
    }).done(function (response) {
      if (!App.isJSONString(response)) {
        return;
      }
      const data = JSON.parse(response);
      for (let i = 0; i < data.length; i++) {
        const entry = data[i];
        let marker = new google.maps.Marker({
          position: new google.maps.LatLng(entry.latitude, entry.longitude),
          map: map,
          title: entry.strasse + ' ' + entry.hausnummer,
          icon: 'assets/template/images/markers/' + entry.status + '.png'
        });
        google.maps.event.addListener(marker, 'click', function (target, elem) {
          App.Api.showReport(entry.meldungid);
        });
        markers.push(marker);
      }
      callback(markers);
    });
  };

  return {
    initialize: function (selector) {
      if (!App.isGoogleLoaded()) {
        return;
      }
      let isLoaded = false;
      const $window = $(window);
      const $map = $(selector);
      if ($map.length > 0) {
        const loadGoogleMap = function () {
          if (isLoaded) {
            return;
          }
          const windowOffset = (window.innerHeight ? window.innerHeight : $window.height()) + $window.scrollTop();
          if (windowOffset >= $map.offset().top - 300) {
            isLoaded = true;
            $window.off("load.gm resize.gm scroll.gm orientationchange.gm");
            initializeMap($map);
          }
        };
        $window.on("load.gm resize.gm scroll.gm orientationchange.gm", function (e) {
          loadGoogleMap();
        });
        loadGoogleMap();
      }
    }
  };
})();

module.exports = GoogleMap;
